import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CustomIconButton from "../common/components/CustomIconButton";
import DashboardIcon from "../iconComponent/dashboardIcon";
import { ROUTE } from "../router/Constant";

const NotAuthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="80vh"
      textAlign="center"
      p={3}
    >
      <Paper
        sx={{
          borderRadius: "12px",
          p: 4,
          maxWidth: "500px",
          width: "100%",
          boxShadow: "0px 4px 6px rgba(85, 71, 221, 0.1)",
          border: "1px solid #f0eff8",
        }}
      >
        <Box display="flex" flexDirection="column" alignItems="center" gap={3}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              color: "#1a1a1a",
              mb: 1,
            }}
          >
            Access Denied
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "#666666",
              lineHeight: 1.6,
              mb: 3,
              maxWidth: "400px",
            }}
          >
            You do not have permission to access this page.
            <br />
            Please contact your administrator if you believe this is a mistake.
          </Typography>

          <CustomIconButton
            text="Go to Dashboard"
            icon={<DashboardIcon />}
            variant="contained"
            onClick={() => navigate(ROUTE.dashboard)}
            size={16}
            height="48px"
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default NotAuthorized;
